import { Logger } from '@gef-ui/logging';
import { throwError, timer } from 'rxjs';
import { mergeMap, retryWhen } from 'rxjs/operators';
export const conditionalRetryWhen = ({ meta, retryTimeout = 1000, retryMaxAttempts = 0, retryExcludedStatusCodes = [] } = {})=>(source)=>retryMaxAttempts > 0 ? source.pipe(retryWhen((attempts)=>attempts.pipe(mergeMap((error, index)=>{
                const retryAttempt = index + 1;
                if (retryAttempt > retryMaxAttempts || retryExcludedStatusCodes.find((e)=>e === error.status)) {
                    return throwError(error);
                }
                Logger.info(`Attempt number: ${retryAttempt} to retry ${meta?.requestUuid}. Retrying in ${retryAttempt * retryTimeout}ms`);
                return timer(retryAttempt * retryTimeout);
            })))) : source;
